"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TemperatureComponent = require("./temperature/TemperatureComponent.vue");

var _TemperatureComponent2 = _interopRequireDefault(_TemperatureComponent);

var _HumidityComponent = require("./humidity/HumidityComponent.vue");

var _HumidityComponent2 = _interopRequireDefault(_HumidityComponent);

var _UVComponent = require("./uv/UVComponent.vue");

var _UVComponent2 = _interopRequireDefault(_UVComponent);

var _RainfallComponent = require("./rainfall/RainfallComponent.vue");

var _RainfallComponent2 = _interopRequireDefault(_RainfallComponent);

var _TimerComponent = require("./timer/TimerComponent.vue");

var _TimerComponent2 = _interopRequireDefault(_TimerComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: ["dico", "currentFarm"],

    components: {
        Temperature: _TemperatureComponent2.default, Humidity: _HumidityComponent2.default, Uv: _UVComponent2.default, Rainfall: _RainfallComponent2.default, Timer: _TimerComponent2.default
    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/infos/InfosComponent.vue
// module id = 394
// module chunks = 0